module.exports = __webpack_public_path__ + "img/10_78.df7a0c96.png";